import { WSQueryConfig } from "@ws-react-query";
import {
  concurrentActions,
  WSServiceError
} from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";
import { QUERY_REQUIREMENT_DEFINITIONS_LIST_All } from "../keys";
import { IRequirementDefinitionResponse } from "@wingspanhq/payments/dist/interfaces";
import times from "lodash/times";
import flatten from "lodash/flatten";
import { listRequirementDefinitions } from "../../../services/requirementDefinitions/listRequirementDefinitions";

export const useRequirementDefinitionListAllQuery = (
  params = {} as any,
  config?: WSQueryConfig<IRequirementDefinitionResponse[], WSServiceError>
) => {
  const { sort, ...filter } = params;

  return useWSQuery<IRequirementDefinitionResponse[], WSServiceError>(
    [QUERY_REQUIREMENT_DEFINITIONS_LIST_All, params],
    async () => {
      const pageSize = 100;
      const {
        summary: { listSize },
        data
      } = await listRequirementDefinitions({
        filter,
        page: { size: pageSize, number: 1 },
        sort
      });

      const pages = Math.ceil(listSize / pageSize) - 1;

      const actions = times(pages).map(
        (_, i) => () =>
          listRequirementDefinitions({
            filter,
            page: { size: pageSize, number: i + 2 },
            sort
          })
      );

      const allPages = await concurrentActions(actions, {
        concurrentLimit: 5
      });

      return flatten([data, ...allPages.map(p => p.data)]);
    },

    {
      refetchOnMount: false,
      retry: false,
      ...config
    }
  );
};
